import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9.93934 1.93934L9.58579 2.29289V2.29289L9.93934 1.93934ZM11 3L11.3536 2.64645V2.64645L11 3ZM12.0607 4.06066L11.7071 4.41421L11.7071 4.41421L12.0607 4.06066ZM12 6.5C12 6.77614 12.2239 7 12.5 7C12.7761 7 13 6.77614 13 6.5H12ZM3 6.5C3 6.77614 3.22386 7 3.5 7C3.77614 7 4 6.77614 4 6.5H3ZM12 14H4V15H12V14ZM5 2H8.87868V1H5V2ZM9.58579 2.29289L10.6464 3.35355L11.3536 2.64645L10.2929 1.58579L9.58579 2.29289ZM10.6464 3.35355L11.7071 4.41421L12.4142 3.70711L11.3536 2.64645L10.6464 3.35355ZM12 5.12132V6.5H13V5.12132H12ZM4 6.5V3H3V6.5H4ZM8.87868 2C9.1439 2 9.39825 2.10536 9.58579 2.29289L10.2929 1.58579C9.91782 1.21071 9.40911 1 8.87868 1V2ZM4 14H4H3C3 14.5523 3.44772 15 4 15V14ZM12 15C12.5523 15 13 14.5523 13 14H12V15ZM11.7071 4.41421C11.8946 4.60175 12 4.8561 12 5.12132H13C13 4.59089 12.7893 4.08218 12.4142 3.70711L11.7071 4.41421ZM5 1C3.89543 1 3 1.89543 3 3H4C4 2.44772 4.44772 2 5 2V1Z"
            fill="currentColor"
        />
        <path
            d="M12.5 5.5H10C9.17157 5.5 8.5 4.82843 8.5 4V1.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.23411 8C3.82397 8 4.28358 8.14646 4.61292 8.43939C4.94717 8.72727 5.1143 9.13636 5.1143 9.66667C5.1143 10.197 4.94717 10.6086 4.61292 10.9015C4.28358 11.1894 3.82397 11.3333 3.23411 11.3333H2.26821V13H1V8H3.23411ZM3.03503 10.3561C3.57082 10.3561 3.83872 10.1263 3.83872 9.66667C3.83872 9.20707 3.57082 8.97727 3.03503 8.97727H2.26821V10.3561H3.03503Z"
            fill="currentColor"
        />
        <path
            d="M7.98966 8C8.75157 8 9.33406 8.21717 9.73713 8.65152C10.1451 9.08586 10.3491 9.70202 10.3491 10.5C10.3491 11.298 10.1451 11.9141 9.73713 12.3485C9.33406 12.7828 8.75157 13 7.98966 13H5.92514V8H7.98966ZM7.86431 12.0152C8.27722 12.0152 8.57707 11.8889 8.76386 11.6364C8.95556 11.3788 9.05142 11 9.05142 10.5C9.05142 10 8.95556 9.62374 8.76386 9.37121C8.57707 9.11364 8.27722 8.98485 7.86431 8.98485H7.19334V12.0152H7.86431Z"
            fill="currentColor"
        />
        <path
            d="M15 9.00758H12.4857V10.0682H14.4912V11.0758H12.4857V13H11.2175V8H15V9.00758Z"
            fill="currentColor"
        />
    </svg>
);

export default Icon;
